import * as React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const comparisonData = [{
  material: "true phenolic",
  bestFor: "Control panels, MIL-SPEC, dielectric needs",
  durability: "High",
  colorRange: "Core engineering colors",
  typicalUse: "Legend plates, nameplates, defense/marine"
}, {
  material: "Two-color acrylic",
  bestFor: "Color range + fast lead time",
  durability: "Good",
  colorRange: "Widest stock range",
  typicalUse: "Legend plates, equipment ID, signage"
}, {
  material: "Stainless steel (304/316)",
  bestFor: "Harsh, high-temp, corrosive, wash-down",
  durability: "Highest",
  colorRange: "Engraved/filled",
  typicalUse: "Valve tags, equipment nameplates, marine"
}, {
  material: "Anodized aluminum",
  bestFor: "Outdoor, UV exposure, light weight",
  durability: "High (outdoor)",
  colorRange: "Anodized colors",
  typicalUse: "Nameplates, data plates, asset tags"
}, {
  material: "Brass",
  bestFor: "Process ID, valves, decorative durability",
  durability: "High (corrosion)",
  colorRange: "Natural/engraved",
  typicalUse: "Valve tags, legacy facility tags"
}];
export default function MaterialComparisonTable() {
  return <section id="material-comparison-table" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="mb-10 space-y-4">
          <h2 className="text-3xl md:text-4xl font-default font-bold text-foreground tracking-tight">
            How Do the Engraving Materials Compare?
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl leading-relaxed">
            A quick comparison of the five materials Evermark Industrial Solutions engraves. Full properties are on each material's spec page.
          </p>
        </div>

        <div className="rounded-lg border border-border bg-card shadow-sm overflow-hidden">
          <Table>
            <TableHeader className="bg-muted/50">
              <TableRow>
                <TableHead className="w-[220px] font-semibold text-foreground">Material</TableHead>
                <TableHead className="font-semibold text-foreground min-w-[200px]">Best For</TableHead>
                <TableHead className="font-semibold text-foreground min-w-[140px]">Durability</TableHead>
                <TableHead className="font-semibold text-foreground min-w-[180px]">Color Range</TableHead>
                <TableHead className="font-semibold text-foreground min-w-[220px]">Typical Use</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {comparisonData.map((row, i) => <TableRow key={i} data-index={i} className="hover:bg-muted/30 transition-colors">
                  <TableCell className="font-medium text-foreground">
                    {row.material}
                  </TableCell>
                  <TableCell className="text-muted-foreground">
                    {row.bestFor}
                  </TableCell>
                  <TableCell className="text-foreground font-medium">
                    {row.durability}
                  </TableCell>
                  <TableCell className="text-muted-foreground">
                    {row.colorRange}
                  </TableCell>
                  <TableCell className="text-muted-foreground">
                    {row.typicalUse}
                  </TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </div>

        <div className="mt-6 rounded-md bg-muted/30 p-4 border border-border/50">
          <p className="text-sm text-muted-foreground italic leading-relaxed">
            Durability and color shown at a glance only; exact ratings are on each spec page. Evermark Industrial Solutions recommends confirming material suitability for safety-critical or chemically aggressive applications with a qualified specialist.
          </p>
        </div>
      </div>
    </section>;
}